module.exports = __webpack_public_path__ + "img/album01_11.bb4407cd.jpg";